import {Component, Input, OnInit} from '@angular/core';
import {AlertController, LoadingController, ToastController} from '@ionic/angular';
import {BaseClass} from '../../../../shared/classes/base';
import {TranslationService} from '../../../../shared/services/translation.service';
import {AttributeRuleCondition, UserRule, UserVisibility} from '../../../_interfaces/user-visibility';
import {UsersService} from '../../../users.service';

@Component({
    selector: 'app-individual-users-rule-list',
    templateUrl: './individual-users-rule-list.component.html',
    styleUrls: ['./individual-users-rule-list.component.scss'],
})
export class IndividualUsersRuleListComponent extends BaseClass implements OnInit {

    @Input() user: UserVisibility = null;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _loadingController: LoadingController,
        private _alertController: AlertController,
        private _usersService: UsersService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
    }

    private async _deleteAttributesRule(rule: AttributeRuleCondition): Promise<void> {
        const loading = await this._loadingController.create();
        loading.present();

        this._usersService.deleteAttributesVisibilityRule(
            this.user.userId, rule.ruleId
        ).subscribe(() => {
            this.notifySuccess();
            loading.dismiss();

        }, (error) => {
            loading.dismiss();
            this.notifyError(error);
        });
    }

    public async confirmDeleteAttributeRule(rule: AttributeRuleCondition): Promise<void> {
        const alert = await this._alertController.create({
            message: this._translationService.getTranslation('visibilityRules.confirmDeleteRule'),
            buttons: [{
                text: this._translationService.getTranslation('generic.cancel'),
                role: 'cancel',
                cssClass: 'danger'
            }, {
                text: this._translationService.getTranslation('generic.editAnyway'),
                handler: () => {
                    this._deleteAttributesRule(rule);
                }
            }]
        });

        await alert.present();
    }

    public async confirmDeleteIndividualRule(rule: UserRule): Promise<void> {
        const alert = await this._alertController.create({
            message: this._translationService.getTranslation('visibilityRules.confirmDeleteRule'),
            buttons: [{
                text: this._translationService.getTranslation('generic.cancel'),
                role: 'cancel',
                cssClass: 'danger'
            }, {
                text: this._translationService.getTranslation('generic.delete'),
                handler: () => {
                    this._deleteIndividualRule(rule);
                }
            }]
        });

        await alert.present();
    }

    private async _deleteIndividualRule(rule: UserRule): Promise<void> {
        const loading = await this._loadingController.create();
        await loading.present();
        this._usersService.deleteIndividualVisibilityRule(this.user.userId, rule.cycleId, rule.userId).subscribe(response => {
            const i = this.user.userRules.findIndex(x => x.cycleParticipantId === rule.cycleParticipantId);
            this.user.userRules.splice(i, 1);
            loading.dismiss();
            this.notifySuccess();
        }, error => {
            loading.dismiss();
            this.notifyError(error);
        });
    }
}
